/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */


/* eslint-enable no-console */
// Ottieni riferimenti agli elementi DOM

/* 
var dwf_modal = document.getElementById('dwf_modal');

// creo una modale se non esiste per evitare che se ne crei una per ogni blocco 
if(!dwf_modal){
	dwf_modal = document.createElement('div');
	dwf_modal.id = "dwf_modal";
	dwf_modal.className = "dwf_modal";

	var dwf_modal_content = document.createElement('div');
	dwf_modal_content.className = "dwf_modal_content";

	let dwf_modal_close = document.createElement('span');
	dwf_modal_close.className = "dwf_modal_close";
	dwf_modal_close.innerText = 'X';
	

	dwf_modal_content.appendChild(dwf_modal_close);
	dwf_modal.appendChild(dwf_modal_content);
	document.body.appendChild(dwf_modal);
}

var dwf_btn_openModal = document.getElementById("dwf_btn_openModal");
var dwf_modal_close = document.querySelector(".dwf_modal_close");

// Quando l'utente clicca sul bottone, apri la finestra modale
// dwf_btn_openModal.onclick = function() {
// 	dwf_modal.style.display = "block";
// }

// Quando l'utente clicca sul pulsante X, chiudi la finestra modale
dwf_modal_close.onclick = function() {
	dwf_modal.style.display = "none";
}

// Quando l'utente clicca fuori dalla finestra modale, chiudila
window.onclick = function(event) {
  if (event.target == dwf_modal) {
    dwf_modal.style.display = "none";
  }
}

 */

// console.log(prova1);
// console.log(prova2);
// console.log(prova3);